/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Sour_Koala_BurnInputs */

const fr_inclusive_sour_koala_burn = /** @type {(inputs: Inclusive_Sour_Koala_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser mon mot de passe`)
};

/**

* @param {Inclusive_Sour_Koala_BurnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_sour_koala_burn = /** @type {((inputs?: Inclusive_Sour_Koala_BurnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Sour_Koala_BurnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_sour_koala_burn(inputs)
});